import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { BaseEditService } from 'tms-lib';
import { Address, AddressDetails, AddressLabel } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class AddressService extends BaseEditService<Address, AddressDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('Address', $localize`Address`);
  }

  getDeliveryAddress(id: string): Observable<AddressLabel> {
    return this.httpService.get<AddressLabel>(`${this.apiUrl}/GetDeliveryAddress?id=${id}`);
  }
}
